import React  from 'react';
// Import Layout Components
// Application
import Application from "../Application/Default/Default";
function Main(props){
  return( <Application {... props}/>)
  }
export default Main;  


// WEBPACK FOOTER //
// ./src/js/pages/Main.js